<template>
    <table class="table is-hoverable is-striped is-fullwidth is-bordered">
        <tbody>
            <tr v-for="row in data">
                <th>{{ row.label }}</th>
                <td>{{ row.value }}</td>
            </tr>
        </tbody>
    </table>
</template>
<script>
export default {
    props: ["data"]
};
</script>
